module.exports = __webpack_public_path__ + "img/landing01.0b1e7685.jpg";